export const IconLinkedIn = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 22 21">
    <path d="M14.527 11.5a2 2 0 0 0-2 2v7h-5s.06-12 0-13h5v1.485s1.548-1.443 3.94-1.443c2.96 0 5.06 2.143 5.06 6.304V20.5h-5v-7a2 2 0 0 0-2-2zm-11.51-6h-.029C1.478 5.5.5 4.318.5 3.019.5 1.69 1.507.607 3.047.607c1.541 0 2.488 1.118 2.518 2.447 0 1.3-.977 2.446-2.548 2.446zm2.51 15h-5v-13h5v13z" />
  </svg>
);
